import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useState } from "react";
import { withRouter } from "react-router";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { Grid } from "@material-ui/core";
import Dropdown from "../../../components/Dropdown/Dropdown";
import { config } from "../../../config/config";
import { updateSourceInputs, updateAlert } from "../../../redux/actions";
import "./rgmretailerview.scss";
import Loader from "../../../components/Loader/Loader";
import { useUserAuthentication } from "../../../utils/utils";
import { useHistory } from "react-router-dom";

let api = config.api.api_url;

function MetaSearchFilter(props) {
  let {
    user,
    source_data,
    setInitial,
    updateAlert,
    setTableLoading,
    setMappedDataCreateNew,
    updateSourceInputs,
    loading,
    setMappedData,
    isSearchFilterLoading,
  } = props;
  const [expand, setExpand] = useState(false);
  let history = useHistory();
  const { login } = useUserAuthentication();

  const is_Approver = useMemo(() => {
    const Is_Role_Approver = user?.role && user?.role?.includes("AppApprover");
    const URL = history?.location?.pathname || [];
    const result = URL.split("/").pop();
    const is_Approver_For_This_Usecase =
      user?.approval_screens && user?.approval_screens?.includes(result);
    return Is_Role_Approver && is_Approver_For_This_Usecase;
  }, [user.role, user.approval_screens]);

  const handleBUChange = async (e, selectedOption) => {
    setInitial(true);
    updateSourceInputs("is_initial", true);
    updateSourceInputs("current_bussines_unit", selectedOption.value);
    updateSourceInputs("current_country", "");
    updateSourceInputs("current_country_code", "");
    updateSourceInputs("current_mapped_country", []);
    updateSourceInputs("current_filter_value", "");

    const params = new URLSearchParams({
      dataset_name: source_data?.data?.dropdown?.mongo_dataset_name || "",
      BU: selectedOption.value || "",
    });

    try {
      const response = await fetch(
        api + `/rgm_retailer_mapping/getcountries?${params}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        }
      );

      const jsonData = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (jsonData?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (!jsonData || !jsonData.data) {
        throw new Error("Unexpected error occured. Please try again later");
      }
      const Countries = jsonData?.data || [];

      const countryOptions =
        Countries?.filter(
          (country) =>
            country !== null && country !== undefined && country !== ""
        )?.map((country) => ({
          label: country,
          value: country,
        })) ?? [];

      updateSourceInputs("current_mapped_country", countryOptions);
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "Failed",
        closeFlag: true,
      });
    }
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("modified_mapped_data", []);
  };

  const handleCountryChange = async (e, selectedOption) => {
    updateSourceInputs("current_filter_value", "");
    setInitial(true);
    updateSourceInputs("is_initial", true);
    setTableLoading(false);
    updateSourceInputs("is_table_loading", false);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("current_country", selectedOption.label);
    updateSourceInputs("current_country_code", selectedOption.value);
  };

  const handleFilterChange = async (e, selectedOption) => {
    updateSourceInputs("current_filter_value", selectedOption.value);
    setMappedData(selectedOption.value);
  };

  return (
    <>
      {!is_Approver && (
        <div className="cnc-toggle-icon">
          <label
            onClick={() => {
              setExpand(!expand);
            }}
          >
            {!expand ? "Collapse" : "Expand"}
          </label>
          <i
            className="material-icons"
            onClick={() => {
              setExpand(!expand);
            }}
          >
            {!expand ? "keyboard_arrow_up" : "keyboard_arrow_down"}
          </i>
        </div>
      )}

      {!expand && (
        <div className="cnc-model-header-mapping">
          <Grid container spacing={4} style={{ padding: "2px 15px 0px 15px" }}>
            {/* BU */}
            <Grid item xs={4} sm={4}>
              <div className="mg-model-header-item" style={{ height: "25px" }}>
                Select BU:{" "}
                <p
                  style={{
                    display: "inline",
                    color: "red",
                    fontSize: 16,
                  }}
                >
                  *
                </p>
              </div>
              <div className="" style={{ marginBottom: "15px" }}>
                <Autocomplete
                  id="country-select"
                  disableClearable
                  size="small"
                  options={source_data.current_bussines_unit_list}
                  loading={
                    loading &&
                    (source_data.current_bussines_unit_list ||
                      source_data.current_bussines_unit_list.length === 0)
                  }
                  loadingText={<Loader />}
                  getOptionLabel={(option) => option.label}
                  onChange={handleBUChange}
                  value={
                    source_data.current_bussines_unit &&
                    source_data.current_bussines_unit.length > 0
                      ? {
                          label: source_data.current_bussines_unit,
                          value: source_data.current_bussines_unit,
                        }
                      : null
                  }
                  popupIcon={
                    <span
                      className="material-icons"
                      style={{
                        fontSize: "20px",
                        color:
                          source_data.current_bussines_unit === ""
                            ? "f7f7f7"
                            : "#555",
                      }}
                    >
                      arrow_drop_down
                    </span>
                  }
                  sx={{
                    width: "100%",
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "#fff",
                      fontFamily: "Hind Siliguri",
                      borderRadius: "6px",
                      fontSize: "13px",
                      fontWeight: "400",
                      color: "#333",
                      height: "36px",
                      paddingRight: "36px", // space for dropdown icon
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: "8px 12px",
                    },
                    "& .MuiAutocomplete-endAdornment": {
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)", // vertical center alignment
                    },
                    "& .MuiSvgIcon-root": {
                      color: "#999",
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      // label="Select Country"
                      InputLabelProps={{
                        style: {
                          fontSize: "13px",
                        },
                      }}
                    />
                  )}
                  renderOption={(props, option) => (
                    <li
                      {...props}
                      style={{
                        fontSize: "12px",
                        fontWeight: "normal",
                        color: "#212529",
                      }}
                    >
                      {option.label}
                    </li>
                  )}
                />
              </div>
            </Grid>

            {/* COUNTRY */}
            <Grid item xs={4} sm={4}>
              <div className="mg-model-header-item" style={{ height: "25px" }}>
                Select Country:{" "}
                <p
                  style={{
                    display: "inline",
                    color: "red",
                    fontSize: 16,
                  }}
                >
                  *
                </p>
              </div>
              <div className="" style={{ marginBottom: "15px" }}>
                <Autocomplete
                  disabled={
                    source_data.current_bussines_unit === "" || loading == true
                      ? true
                      : false
                  }
                  id="country-select"
                  disableClearable
                  size="small"
                  options={source_data.current_mapped_country}
                  loading={
                    loading &&
                    (!source_data.current_mapped_country ||
                      source_data.current_mapped_country.length === 0)
                  }
                  loadingText={<Loader />}
                  getOptionLabel={(option) => option.label}
                  onChange={handleCountryChange}
                  value={
                    source_data.current_country &&
                    source_data.current_country.length > 0
                      ? {
                          label: source_data.current_country,
                          value: source_data.current_country,
                        }
                      : null
                  }
                  popupIcon={
                    <span
                      className="material-icons"
                      style={{
                        fontSize: "20px",
                        color:
                          source_data.current_bussines_unit === ""
                            ? "f7f7f7"
                            : "#555",
                      }}
                    >
                      arrow_drop_down
                    </span>
                  }
                  sx={{
                    width: "100%",
                    "& .MuiOutlinedInput-root": {
                      backgroundColor:
                        source_data.current_bussines_unit === ""
                          ? "#d6d6d6"
                          : "#fff",
                      fontFamily: "Hind Siliguri",
                      borderRadius: "6px",
                      fontSize: "13px",
                      fontWeight: "400",
                      color: "#333",
                      height: "36px",
                      paddingRight: "36px", // space for dropdown icon
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: "8px 12px",
                    },
                    "& .MuiAutocomplete-endAdornment": {
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)", // vertical center alignment
                    },
                    "& .MuiSvgIcon-root": {
                      color: "#999",
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      // label="Select Country"
                      InputLabelProps={{
                        style: {
                          fontSize: "13px",
                        },
                      }}
                    />
                  )}
                  renderOption={(props, option) => (
                    <li
                      {...props}
                      style={{
                        fontSize: "12px",
                        fontWeight: "normal",
                        color: "#212529",
                      }}
                    >
                      {option.label}
                    </li>
                  )}
                />
              </div>
            </Grid>

            {/* Filters */}
            <Grid item xs={4} sm={4}>
              <div className="mg-model-header-item" style={{ height: "25px" }}>
                Choose Filter:{" "}
                <p
                  style={{
                    display: "inline",
                    color: "red",
                    fontSize: 16,
                  }}
                >
                  *
                </p>
              </div>
              <div className="" style={{ marginBottom: "15px" }}>
                <Autocomplete
                  disabled={source_data.current_country === "" ? true : false}
                  id="country-select"
                  disableClearable
                  size="small"
                  options={source_data.current_filters}
                  loading={
                    source_data.current_filters ||
                    source_data.current_filters.length === 0
                  }
                  loadingText={<Loader />}
                  getOptionLabel={(option) => option.label}
                  onChange={handleFilterChange}
                  value={
                    source_data.current_filter_value &&
                    source_data.current_filter_value.length > 0
                      ? {
                          label: source_data.current_filter_value,
                          value: source_data.current_filter_value,
                        }
                      : null
                  }
                  popupIcon={
                    <span
                      className="material-icons"
                      style={{
                        fontSize: "20px",
                        color:
                          source_data.current_country === ""
                            ? "f7f7f7"
                            : "#555",
                      }}
                    >
                      arrow_drop_down
                    </span>
                  }
                  sx={{
                    width: "100%",
                    "& .MuiOutlinedInput-root": {
                      backgroundColor:
                        source_data.current_country === "" ? "#d6d6d6" : "#fff",
                      fontFamily: "Hind Siliguri",
                      borderRadius: "6px",
                      fontSize: "13px",
                      fontWeight: "400",
                      color: "#333",
                      height: "36px",
                      paddingRight: "36px", // space for dropdown icon
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: "8px 12px",
                    },
                    "& .MuiAutocomplete-endAdornment": {
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)", // vertical center alignment
                    },
                    "& .MuiSvgIcon-root": {
                      color: "#999",
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      // label="Select Country"
                      InputLabelProps={{
                        style: {
                          fontSize: "13px",
                        },
                      }}
                    />
                  )}
                  renderOption={(props, option) => (
                    <li
                      {...props}
                      style={{
                        fontSize: "12px",
                        fontWeight: "normal",
                        color: "#212529",
                      }}
                    >
                      {option.label}
                    </li>
                  )}
                />
              </div>
            </Grid>
          </Grid>
        </div>
      )}
    </>
  );
}

MetaSearchFilter.propTypes = {
  source_data: PropTypes.object,
  updateSourceInputs: PropTypes.func,
};

const mapStateToProps = (state) => ({
  source_data: state.source,
  user: state.user,
});

const mapDispatchToProps = {
  updateSourceInputs,
  updateAlert,
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MetaSearchFilter)
);
